import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initMetaPixel } from "./utils/metaPixel";

// Conexiones tempranas a Google Fonts + preload de la imagen del hero (LCP).
function addHeadHints() {
  const hints: Array<Record<string, string>> = [{
    rel: "preconnect",
    href: "https://fonts.googleapis.com"
  }, {
    rel: "preconnect",
    href: "https://fonts.gstatic.com",
    crossOrigin: "anonymous"
  }, {
    rel: "preconnect",
    href: "https://cdn.magicpatterns.com"
  }, {
    rel: "preconnect",
    href: "https://connect.facebook.net"
  }, {
    rel: "preload",
    as: "image",
    href: "https://cdn.magicpatterns.com/uploads/e5Vr3B73oQ1gfTJhkR77hU/mockup_hero.webp",
    fetchpriority: "high"
  }];
  hints.forEach(hint => {
    const link = document.createElement("link");
    Object.entries(hint).forEach(([key, value]) => {
      if (key === "crossOrigin") {
        link.crossOrigin = value;
      } else {
        link.setAttribute(key.toLowerCase(), value);
      }
    });
    document.head.appendChild(link);
  });
}
addHeadHints();
initMetaPixel();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-310" data-mp="10otxfzp5cxhx" />);
}